import { lazy } from 'react';

const SellerDiscountSettingRoutes = [
  {
    path: 'seller/discount-settings',
    component: lazy(() => import('views/seller-views/discount-settings')),
  },
  {
    path: 'seller/discount-settings/add',
    component: lazy(() =>
      import('views/seller-views/discount-settings/discount-setting-add'),
    ),
  },
  {
    path: 'seller/discount-settings/:id',
    component: lazy(() =>
      import('views/seller-views/discount-settings/discount-setting-edit'),
    ),
  },
];

export default SellerDiscountSettingRoutes;